<script>
  import MenuHeading from "./../../shared/MenuHeading.svelte";
  import axios from "axios";
  import config from "../../stores/config";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import { onMount } from "svelte";
  import r from "react-image-file-resizer";
  import loadData from "../../utils/loadData";

  export let hasPhoto = false;
  export let hasGraphic = false;

  export let styleID;

  let fPhoto = null;
  let fGraphic = null;
  let resize = r.imageFileResizer;
  let resizeImage;
  let errCount = 0;

  let uploadingPic = false;
  let uploadingGraphic = false;

  onMount(async () => {
    console.log({ hasPhoto, hasGraphic });

    resizeImage = (file) => {
      return new Promise((resolve, reject) => {
        resize(file, 500, 500, "JPEG", 50, 0, (uri) => resolve(uri), "blob");
      });
    };
  });

  const handlePic = async (e) => {
    if (!fPhoto) {
      alert("Final Photo missing!");
      return;
    } else {
      uploadingPic = true;

      const formData = new FormData();

      let resizedImg;

      resizedImg = await resizeImage(fPhoto[0]);
      formData.append("photo", resizedImg);

      axios
        .put(
          `${$config.backendURL}/fstyles/${styleID}/draughtsman-pic`,
          formData,
          {
            headers: { authorization: ls.get("jwt") },
          }
        )
        .then((res) => {
          console.log(res.data);
          uploadingPic = false;
          alert(`☑ Added Successfully`);
          errCount = 0;
          loadData();
        })
        .catch((err) => {
          uploadingPic = false;
          errCount++;
          if (errCount <= 3) {
            handlePic();
            console.log(`Retrying... ${errCount}`);
          } else {
            console.log(`Done Retrying... xxx`);
            console.log(err);
            alert("There was a problem, Refresh the page and retry");
          }
        });
    }
  };

  const handleGraphic = async (e) => {
    if (!fGraphic) {
      alert("Final Graphic missing!");
      return;
    } else {
      uploadingGraphic = true;

      const formData = new FormData();

      let resizedImg;

      resizedImg = await resizeImage(fGraphic[0]);
      formData.append("graphic", resizedImg);

      axios
        .put(
          `${$config.backendURL}/fstyles/${styleID}/draughtsman-graphic`,
          formData,
          {
            headers: { authorization: ls.get("jwt") },
          }
        )
        .then((res) => {
          console.log(res.data);
          uploadingGraphic = false;
          alert(`☑ Added Successfully`);
          errCount = 0;
          loadData();
        })
        .catch((err) => {
          uploadingGraphic = false;
          errCount++;
          if (errCount <= 3) {
            handleGraphic();
            console.log(`Retrying... ${errCount}`);
          } else {
            console.log(`Done Retrying... xxx`);
            console.log(err);
            alert("There was a problem, Refresh the page and retry");
          }
        });
    }
  };
</script>

<form class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8">
  <div class="col-span-full -mt-10">
    <MenuHeading
      title="Final photos"
      description="Add the draughtsman photos here."
    />
  </div>

  <div class="grid grid-cols-4 gap-4 -mt-6">
    {#if !hasPhoto}
      <div class="flex items-center w-full">
        <label
          for="product-pic"
          class:border-brand={fPhoto}
          class:text-brand={fPhoto}
          class:border-gray-200={!fPhoto}
          class:text-gray-300={!fPhoto}
          class="w-full py-2 px-4 flex items-center justify-start cursor-pointer h-full bg-white rounded-xl border shadow-sm"
        >
          {#if fPhoto}
            <i class="fas fa-check-circle text-brand text-base mr-2" />
            Photo Selected
          {:else}
            <i class="fas fa-camera text-base mr-2" />
            Final Photo
          {/if}
        </label>
      </div>

      {#if uploadingPic}
        <div class="grid grid-cols-1 gap-8">
          <div class="flex items-center justify-center btn btn-primary-outline">
            <Wave size="25" color="rgb(244,162,97)" unit="px" />
            <span class="ml-4">Please wait...</span>
          </div>
        </div>
      {:else}
        <div class="">
          <button
            class="btn btn-primary"
            style="width: 100% !important;"
            on:click={handlePic}
          >
            <i class="fas fa-check-circle mr-3" />
            Save Final Photo
          </button>
        </div>
      {/if}
    {:else}
      <div class="col-span-2 flex items-center">
        🟢 FINAL PHOTO ALREADY ADDED
      </div>
    {/if}

    {#if !hasGraphic}
      <div class="flex items-center w-full">
        <label
          for="product-graphic"
          class:border-brand={fGraphic}
          class:text-brand={fGraphic}
          class:border-gray-200={!fGraphic}
          class:text-gray-300={!fGraphic}
          class="w-full py-2 px-4 flex items-center justify-start cursor-pointer h-full bg-white rounded-xl border shadow-sm"
        >
          {#if fGraphic}
            <i class="fas fa-check-circle text-brand text-base mr-2" />
            Graphic Selected
          {:else}
            <i class="fas fa-image text-base mr-2" />
            Final Graphic
          {/if}
        </label>
      </div>

      {#if uploadingGraphic}
        <div class="grid grid-cols-1 gap-8">
          <div class="flex items-center justify-center btn btn-primary-outline">
            <Wave size="25" color="rgb(244,162,97)" unit="px" />
            <span class="ml-4">Please wait...</span>
          </div>
        </div>
      {:else}
        <div class="">
          <button
            class="btn btn-primary"
            style="width: 100% !important;"
            on:click={handleGraphic}
          >
            <i class="fas fa-check-circle mr-3" />
            Save Final Graphic
          </button>
        </div>
      {/if}

      <div class="hidden">
        <input
          bind:files={fPhoto}
          type="file"
          accept="image/*"
          id="product-pic"
          class="appearance-none"
        />
      </div>

      <div class="hidden">
        <input
          bind:files={fGraphic}
          type="file"
          accept="image/*"
          id="product-graphic"
          class="appearance-none"
        />
      </div>
    {:else}
      <div class="col-span-2 flex items-center">
        🟢 FINAL GRAPHIC ALREADY ADDED
      </div>
    {/if}
  </div>
</form>
